import cloneDeep from "lodash-es/cloneDeep";
import groupBy from "lodash-es/groupBy";
import {dayjsInstance} from "../../utils/date";
import {postRequest} from "../api";

export const observableKey = ({type, value}) => {
  return `${type}:${value}`;
};

export const processDispositionData = (data, observable) => {
  const counter = {},
    verdicts = [];

  let disposition;

  if (data && data.data) {
    data.data.forEach(module => {
      if (module.data.verdicts) {
        const filtered = module.data.verdicts.docs.filter(doc => {
          doc.module_instance_id = module.module_instance_id;
          doc.module = module.module;

          if (!doc.observable) {
            return false;
          }

          if (doc.valid_time) {
            const endTime = dayjsInstance(doc.valid_time.end_time),
              diff = endTime.diff(dayjsInstance());

            if (diff <= 0) {
              return false;
            }
          }

          return (
            doc.observable.type === observable.type &&
            doc.observable.value === observable.value
          );
        });

        const groups = groupBy(filtered, "disposition");

        for (let [k, v] of Object.entries(groups)) {
          if (!counter[k]) {
            counter[k] = [];
          }

          counter[k] = counter[k].concat(v);
        }
      }
    });

    for (let i = 1; i <= 5; i++) {
      const dispositionGroup = counter[i];

      if (dispositionGroup && dispositionGroup.length) {
        counter[i].sort((a, b) => {
          const aStart = new Date(a.valid_time.start_time),
            bStart = new Date(b.valid_time.start_time);

          return aStart.getTime() < bStart.getTime() ? a : b;
        });

        // Remove unecessary data
        dispositionGroup.forEach(g => {
          delete g.observable;
          delete g.type;
          delete g.disposition_name;
        });

        if (!disposition) {
          disposition = i;
        }

        verdicts.push(...dispositionGroup);
      }
    }
  }

  return {
    disposition: disposition || 5,
    verdicts
  };
};

export const addDispositionFromCache = (observables, cache) => {
  const dispositions = cloneDeep(observables);

  dispositions.forEach(obs => {
    const result = cache[observableKey(obs)];

    if (result) {
      obs.disposition = result.disposition;
      obs.verdicts = result.verdicts;
    }
  });

  return dispositions;
};

export const mergeObservables = (original = [], updated = []) => {
  const isUpdatedArray = Array.isArray(updated),
    mapped = {};

  if (isUpdatedArray) {
    updated.forEach(d => {
      mapped[observableKey(d)] = {
        disposition: d.disposition,
        verdicts: d.verdicts,
        status: d.status
      };
    });
  } else {
    Object.assign(mapped, updated);
  }

  let matched = false;

  original.forEach(o => {
    const key = observableKey(o);

    if (mapped[key]) {
      if (
        o.disposition !== mapped[key].disposition ||
        o.status !== mapped[key].status
      ) {
        ["disposition", "verdicts", "status"].forEach(k => {
          const value = mapped[key][k];

          if (value) {
            o[k] = value;
          }
        });

        matched = true;
      }
    }
  });

  return matched;
};

export const getDispositions = toFetch => {
  return postRequest("/iroh/iroh-enrich/deliberate/observables", toFetch);
};
